import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { FileParameter, ICompany, IThemeLineItem, ListManufacturersRequest, ListThemeLineItemTypesRequest, SituViewWebApiClient, ThemeLineItem } from 'situview-webapi-client';
import { AuthService, BreadcrumbService, StateService } from 'src/app/services';
import { Router } from '@angular/router';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { ViewControls } from 'src/app/shared/models/view-controls';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'themes-imported-lines',
  templateUrl: './themes-imported-lines.component.html',
  styleUrls: ['./themes-imported-lines.component.scss']
})

export class ThemesImportedLinesComponent extends SituBaseComponent {
  viewControls = {
    pageIndex: 0,
    pageSize: 25,
    totalItems: 0,
    pageSizeOptions: [25, 50, 100],
    displayedColumns: ['name', 'logoUrl', 'disabled', 'cta']
  } as ViewControls;

  private _loading = false;
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  enabledOnly: boolean = true;
  previousSearchTerm = "";
  searchTerm = "";
  admin = false;
  dataSource = new MatTableDataSource<ThemeLineItem>();

  filename: string | undefined;

  constructor(
    authService: AuthService,
    stateService: StateService,
    private situViewWebApiClient: SituViewWebApiClient,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private snackBar: MatSnackBar) {
    super(authService, stateService);
  }

  protected onSelectedCompanyChange(): void {
    this.loadThemeLineItems();
  }

  onClickAddCompany() {
    this.router.navigate([`/admin/companies/add`]);
  }

  loadThemeLineItems() {
    this.loading = true;

    let request = new ListThemeLineItemTypesRequest();

    if (this.searchTermChanged()) this.resetSearch();
    // request.pageNumber = this.viewControls.pageIndex + 1;
    // request.pageSize = this.viewControls.pageSize;
    // request.searchTerm = this.searchTerm;
    // request.enabled = this.enabledOnly;
    this.previousSearchTerm = this.searchTerm;

    return this.situViewWebApiClient.listThemeLineItems(request).then(response => {
      this.dataSource.data = response.themeLineItems ?? [];
      this.viewControls.totalItems = response.themeLineItems?.length ?? 0;
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  onFileChosen(event: any) {
    var fileExt = event.target.files[0].name.split('.').pop();
    if (fileExt !== 'xlsx') {
      this.showMessage("Only Excel spreadsheets are allowed");
      return;
    }

    let fileParameter: FileParameter[] | null | undefined = [{ data: event.target.files[0], fileName: event.target.files[0].name }];

    this.situViewWebApiClient.importThemes(this.selectedCompany?.id, fileParameter).then((response) => {
      if (response.success) {
        this.showMessage("Product file uploaded");
        //this.notificationService.updateImportedProductsNotification();
        //this.router.navigate(['/products-import-preview']);
        this.loadThemeLineItems();
      }
      else {
        this.showMessage("There was an issue importing the product file")
      }
    });
  }

  onImportThemesClick() {
    document.getElementById("uploaded-product-file")?.click();
  }

  onEditManufacturer(companyId: string) {
    this.router.navigate([`/admin/companies/${companyId}`]);
  }

  onViewCompany(manufacturerId: string) {
    this.router.navigate([`/admin/companies/${manufacturerId}/dashboard`]);
  }

  onPageChange(event: PageEvent) {
    this.viewControls.pageSize = event.pageSize;
    this.viewControls.pageIndex = event.pageIndex;

    this.loadThemeLineItems();
  }

  resetSearch() {
    this.viewControls.pageIndex = 0;
    this.viewControls.pageSize = 25;
    this.viewControls.totalItems = 0;
  }

  private searchTermChanged(): boolean {
    return this.searchTerm.toLowerCase() !== this.previousSearchTerm.toLowerCase();
  }

  showMessage(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000
    });
  }
}
